import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { RulesName, RulesType } from '../../../enums';
import {formatPricesByCountry, hasAllUrns} from "../../../utils/products";
import { format, subDays } from 'date-fns';

const SummaryItem = ({ item, availableSalePriceOffer, applyTrial, products, couponInfo, isByCoupon, user, setHasProrated, recurrenceToShow, recurrenceToShowInsummary }) => {
  const renderIncludedAddOns = (item) => {
    const addOnsToInclude = item?.rules?.[RulesType.PURCHASE]?.[RulesName.PLAN_INCLUDE_ADDONS];
    if (!addOnsToInclude || addOnsToInclude.length === 0) return <></>;
    return addOnsToInclude.map((addOn, index) => {
      const addOnInfo = products.find(p => p.productID === addOn.productId);
      return (
        <div key={index} className="subtitle__item-name">
          <span>
            <FormattedMessage
              id="MembershipSelectionPage.summary.includeAddonInPlan"
              values={{
                name: addOnInfo?.name
              }}
            />
          </span>
        </div>
      )
    });
  }

  const priceToShow = (product) => {
    let priceToShow;
    if (product.grossPriceToShow) {
      priceToShow = product.grossPriceToShow
    } else {
      priceToShow = product.priceToShow
    }
    return formatPricesByCountry(priceToShow, user.country)
  }

  const subtractOneDay = (dateToSubtract) => {
    const originalDate = new Date(dateToSubtract);
    const subtractedDay = subDays(originalDate, 1);
    return format(subtractedDay, 'dd/MM/yyyy');
  }

  const hasProrated = () => {
    const prorated = !hasAllUrns(item, user) && item.productType === 'plan' && item.daysDifference !== 0 && !applyTrial;

    setHasProrated(prorated);

    return prorated
  }

  return (
    <>
      <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>
          {item.name}
          {renderIncludedAddOns(item)}
        </div>
        <div className={{ display: 'flex', flexDirection: 'column' }}>
          <div className="summaryCoupon__amount">
            <span className="price">
              {priceToShow(item)}
            </span>
          </div>
        </div>
      </div>
      {applyTrial && (
        <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span className="price">
            <FormattedMessage id="MembershipSelectionPage.summary.freeTrial" />
          </span>
          <p className="subtitle">
            <span style={{ marginRight: '2px' }}>{item.trial.amount}</span>
            {item.trial.amount === 1 ? (
              <FormattedMessage
                id={`MembershipSelectionPage.addOn.trial.${item.trial.unit}.one`}
                values={{
                  unit: item.trial?.unit ?? 'month'
                }}
              />
            ) : (
              <FormattedMessage
                id={`MembershipSelectionPage.addOn.trial.${item.trial.unit}`}
                values={{
                  unit: item.trial?.unit ?? 'month'
                }}
              />
            )}
          </p>
        </div>
      )}
      {!applyTrial && availableSalePriceOffer && (
        <>
          <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
              <FormattedMessage id="MembershipSelectionPage.summary.discountAmount" />
              {availableSalePriceOffer?.discountType === 'percentage' && ` (${availableSalePriceOffer?.amount}%)`}
            </div>
            <div className={{ display: 'flex', flexDirection: 'column' }}>
              <div className="summaryCoupon__amount">
                <span className="price">
                  {formatPricesByCountry(item?.grossPriceToShow - item?.priceToShow, user.country)}
                </span>
              </div>
            </div>
          </div>
          <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
              <FormattedMessage id="MembershipSelectionPage.summary.salePrice.until" />
            </div>
            <div className={{ display: 'flex', flexDirection: 'column' }}>
              <div className="summaryCoupon__amount">
                <span className="price">
                  {format(new Date(availableSalePriceOffer.to.split('T')[0]), 'dd/MM/yyyy')}
                </span>
              </div>
            </div>
          </div>
        </>
      )}
      {
        isByCoupon && !applyTrial &&
          <>
            <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>
                <FormattedMessage id="MembershipSelectionPage.summary.discountAmount" />
                {couponInfo?.type === 'percentage' && ` \n(${couponInfo?.discount}%)`}
              </div>
              <div className={{ display: 'flex', flexDirection: 'column' }}>
                <div className="summaryCoupon__amount">
                  <span className="price">
                    {formatPricesByCountry((item?.priceToShow - item?.discountPriceToShow), user.country)}
                  </span>
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>
                <FormattedMessage id="MembershipSelectionPage.summary.couponDuration" />
              </div>
              <div className={{ display: 'flex', flexDirection: 'column' }}>
                <div className="summaryCoupon__amount">
                  <span className="price">
                  {
                      parseInt(couponInfo?.cycles) ?
                      <FormattedMessage id={'MembershipSelectionPage.summary.cycles'}
                        values={{
                          cycleNumber: couponInfo?.cyclesDuration === 'forever' ? '' : couponInfo?.cycles,
                          duration: couponInfo?.cyclesDuration === 'forever' ? <FormattedMessage id={`MembershipSelectionPage.summary.${couponInfo?.cyclesDuration}`} /> : recurrenceToShowInsummary
                        }}
                      /> :
                      <FormattedMessage id={`MembershipSelectionPage.summary.${couponInfo?.duration}`} />
                    }
                  </span>
                </div>
              </div>
            </div>
          </>
      }
      {hasAllUrns(item, user) && item.productType === 'plan' && (
        <div className="mb-2">
          <FormattedMessage
            id="MembershipSelectionPage.summary.hasAllUrn"
          />
        </div>
      )}
      {hasProrated() && (
        <>
          <div className="mb-2">
            <FormattedMessage
              id="MembershipSelectionPage.summary.plan.prorated"
              values={{
                price: formatPricesByCountry(item.discountPriceToShow, user.country),
              }}
            />
          </div>
          <div>
            <FormattedMessage
              id="MembershipSelectionPage.summary.plan.newExpirationDate"
              values={{
                date: item?.expiresAt ? subtractOneDay(item.expiresAt) : ''
              }}
            />
          </div>
        </>
      )}
    </>
  );
}

SummaryItem.propTypes = {
  item: PropTypes.shape({
    isIncludedInPlan: PropTypes.bool,
    name: PropTypes.string,
    rules: PropTypes.object,
    applyApportionment: PropTypes.bool,
    daysDifference: PropTypes.number,
    priceToShow: PropTypes.number,
    currency: PropTypes.string,
    discountPriceToShow: PropTypes.number,
    trial: PropTypes.object,
    grossPriceToShow: PropTypes.number,
    productType: PropTypes.string
  }),
  products: PropTypes.array,
  applyTrial: PropTypes.bool,
  couponInfo: PropTypes.shape({
    code: PropTypes.string,
    type: PropTypes.string,
    products: PropTypes.arrayOf(PropTypes.string),
    discount: PropTypes.number,
    duration: PropTypes.string
  }),
  isByCoupon: PropTypes.bool,
  availableSalePriceOffer: PropTypes.bool,
  user: PropTypes.object,
  setHasProrated: PropTypes.func
};

export default SummaryItem;
